export default __webpack_public_path__ + "static/media/error.1e1b6c9c.png";